module.exports = __webpack_public_path__ + "img/icon-caution.a8950e2b.svg";